<header class="bg-header dark:bg-dark-header text-white shadow w-full dark:border-dark-header dark:border-b no-print"
  *ngIf="!isPreviewRoute">
  <div class="flex justify-between items-stretch h-[70px] px-4 w-full">
    <!-- Default/WARFIGHTERS theme -->
    <div
      class="wf-brand flex flex-shrink-0 flex-row items-center relative -ml-4 pl-4 h-full min-w-0 cursor-pointer group select-none"
      *ngIf="currentTheme === 'WARFIGHTERS' || currentTheme === environment.defaultTheme"
      (click)="goHome()"
    >
      <div class="absolute inset-y-0 left-0 w-[min(100%,18rem)] sm:w-72 bg-gradient-to-r from-white/75 via-white/40 to-transparent pointer-events-none"></div>

      <img
        class="relative z-10 h-14 w-14 sm:h-16 sm:w-16 object-contain shrink-0 drop-shadow-md transition-transform duration-200 group-hover:scale-[1.03]"
        alt="OE"
        src="./../../../assets/logos/oe logo.png"
        priority
      />

      <div class="relative z-10 hidden sm:block w-px h-10 bg-black/15 mx-3 shrink-0"></div>

      <div class="relative z-10 title-container font-brand flex min-h-12 flex-col justify-center gap-1 text-black py-0.5 min-w-0">
        <span class="text-xl sm:text-2xl font-extrabold tracking-tight leading-none">{{ title1 }}</span>
        <div class="flex flex-row items-center gap-2 min-w-0">
          <span class="text-xs sm:text-sm font-medium uppercase tracking-[0.22em] text-black/80 leading-none truncate">{{ title2 }}</span>
          <span
            class="inline-flex shrink-0 items-center text-[9px] sm:text-[10px] font-semibold tabular-nums text-black/65 bg-black/5 border border-black/10 px-1.5 py-0.5 rounded-sm leading-none"
          >{{ version }}</span>
        </div>
      </div>
    </div>

    <!-- PavCon theme -->
    <div class="flex flex-shrink-0 flex-row gap-1 items-center rounded-md border-gray-50 relative -ml-4 pl-4"
      *ngIf="currentTheme === 'PavCon'">
      <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent"></div>
      <div class="relative z-10">
        <img class="h-10 mt-2" alt="PavCon" src="./../../../assets/logos/pavcon.png" (click)="goHome()" priority />
      </div>
      <div
        class="title-container relative z-10 font-brand flex min-h-12 flex-col justify-center gap-0 -mt-2.5 cursor-pointer subpixel-antialiased"
        (click)="goHome()"
      >
        <span class="mt-2 text-base sm:text-lg text-white font-semibold tracking-tight leading-none">Data Capture</span>
        <div class="flex flex-row items-center gap-1.5">
          <span class="text-md text-white/95 font-medium tracking-wide leading-none">Platform</span>
          <span
            class="mt-1 inline-flex items-center text-[9px] font-medium tabular-nums text-gray-900 bg-white/80 px-1 py-px rounded leading-none shadow-sm"
          >{{ version }}</span>
        </div>
      </div>
    </div>





    <!-- SAFiRE theme -->
    <div class="flex flex-shrink-0 flex-row gap-1 items-center rounded-md border-gray-50 relative -ml-4 pl-4"
      *ngIf="currentTheme === 'SAFiRE'">
      <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent"></div>
      <div class="relative z-10">
        <img class="h-16 mt-0" alt="SAFiRE" src="./../../../assets/logos/safire.png" (click)="goHome()" priority />
      </div>
      <div
        class="title-container relative z-10 font-brand flex min-h-16 flex-col justify-center gap-px cursor-pointer subpixel-antialiased"
        (click)="goHome()"
      >
        <span class="text-lg text-white font-semibold tracking-tight leading-none">FY27 Submissions</span>
        <div class="flex flex-row items-center gap-1.5">
          <span class="text-sm text-white/95 font-light tracking-wide leading-none">Call for Proposals</span>
          <span
            class="inline-flex items-center text-[10px] font-medium tabular-nums text-gray-900 bg-white/80 px-1 py-px rounded leading-none shadow-sm"
          >{{ version }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50" *ngIf="currentTheme === 'SAFiRE'">
      <img class="h-16 mt-0 shadow-lg" alt="SAFiRE" src="./../../../assets/logos/safire.png" (click)="goHome()"
        priority />
      <div class="title-container" (click)="goHome()">
        <span class="text-lg text-white font-bold">SAFiRE</span>
        <div class="flex flex-row gap-1 items-start">

          <span class="text-gray-200 text-xs">{{ version }}</span>
        </div>
      </div>
    </div> -->

    <div class="toolbar-right flex items-center flex-1 min-w-0 justify-end gap-2 ml-auto md:ml-6 h-full -mr-4">
      <app-project-selector
        *ngIf="isAdminRoute && currentUser && (currentUser.sub.length > 0) && isAdmin && (projects && projects.length > 0)"
        [projects]="projects" [ngModel]="selectedProject" placeholder="Select a project..."
        searchPlaceholder="Search projects..." width="350px" maxHeight="400px"
        (selectionChange)="onProjectChanged($event)">
      </app-project-selector>

      @if (isAdminRoute) {
        <div class="toolbar-corner flex items-center shrink-0 pl-4 relative h-full self-stretch" #userMenuContainer>
          <button
            id="user-menu-button"
            #userMenuTrigger
            aria-label="Account menu"
            type="button"
            class="user-block-trigger h-full pl-4 pr-4 flex items-center gap-3 text-left"
            (click)="toggleUserMenu()"
          >
            <span
              class="user-avatar w-10 h-10 min-w-[40px] min-h-[40px] rounded-full flex items-center justify-center shrink-0 bg-white border border-white/30 shadow-sm"
            >
              @if (userInitials) {
                <span class="user-initials text-sm font-semibold uppercase leading-none select-none text-gray-800">{{ userInitials }}</span>
              } @else {
                <mat-icon fontIcon="person" class="!w-5 !h-5 text-gray-600"></mat-icon>
              }
            </span>
            @if (userFullName || userEmail) {
              <div class="user-info hidden min-w-0 sm:flex flex-col items-start justify-center">
                @if (userFullName) {
                  <span class="user-name text-white font-medium text-sm leading-tight truncate max-w-[180px]" [title]="userFullName">{{ userFullName }}</span>
                }
                @if (userEmail) {
                  <span class="user-email text-white/85 text-xs leading-tight truncate max-w-[180px]" [title]="userEmail">{{ userEmail }}</span>
                }
              </div>
            }
            <mat-icon fontIcon="arrow_drop_down" class="user-chevron shrink-0 text-white"></mat-icon>
          </button>
          @if (userMenuOpen) {
            <div
              class="absolute top-full right-0 z-10 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              [style.width.px]="dropdownWidth"
              [style.minWidth.px]="dropdownWidth"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
              tabindex="-1"
            >
              <div class="py-1" role="none">
                <button (click)="goToApplicationsLauncher(); userMenuOpen = false"
                  class="w-full text-left text-gray-700 block px-3 py-2 text-sm hover:bg-gray-100 flex items-center whitespace-nowrap"
                  role="menuitem"
                  tabindex="-1"
                  id="user-menu-item-0"
                >
                  <mat-icon fontIcon="apps" class="!w-5 !h-5 mr-2 text-blue-500 shrink-0"></mat-icon>
                  Return to Apps Launcher
                </button>
                <div class="border-t border-gray-200 my-1"></div>
                <button (click)="signOut(); userMenuOpen = false"
                  class="w-full text-left text-gray-700 block px-3 py-2 text-sm hover:bg-gray-100 flex items-center whitespace-nowrap"
                  role="menuitem"
                  tabindex="-1"
                  id="user-menu-item-1"
                >
                  <mat-icon fontIcon="logout" class="!w-5 !h-5 mr-2 text-red-500 shrink-0"></mat-icon>
                  Logout
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</header>
